import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTabs = createCustomElementWrapper('kat-tabs', 'KatTabs', {
    'fullWidthTabs': 'full-width-tabs',
    'tabsBeforeOverflow': 'tabs-before-overflow',
}, {
    'onChange': 'change',
});
